import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import ImageIcon from '@mui/icons-material/Image';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ConfirmAction from "../../components/Common/ConfirmAction";
import { IReduxState } from "../../store";
import { deleteApplication, updateActualite, updateApplication } from "../../store/siteWebSlice";
import { SITEWEB_SERVER_BASE_URL, apiClient } from "../../util/apiClient";
import { convertToBase64, errorNotify, successNotify } from "../../util/functions";
import PostEditDialog from "../components/PostEditDialog";
import Edit from "./Edit";
import EditImageIllustration from "./EditImageIllustration";


export default function MenuApp(props: any) {
  //props
  const {
    item
  } = props;

  //redux
  const dispatch = useDispatch()
  const { applications } = useSelector((state: IReduxState) => state.siteWeb);

  //hooks
  //menu
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  //edition
  const [editLoading, setEditUserLoading] = useState(false);
  const [openEdition, setOpenEdition] = useState(false);
  const [editionApplication, setEditionApplication] = useState<any>({})
  const [selectedPhoto, setSelectedPhoto] = useState<any>("")
  const [arrayToEdit, setArrayToEdit] = useState<any>([])

  //suppression
  const [openSuppression, setOpenSuppression] = useState(false)
  const [suppressionLoading, setSuppressionLoading] = useState(false);

  //ImageIllustration
  const [openEditionImageIllustrationDialog, setOpenEditionImageIllustrationDialog] = useState<boolean>(false)
  const [loadingEditionImageIllustration, setLoadingEditionImageIllustration] = useState(false)
  const [arrayImageIllustrationToEdit, setArrayImageIllustrationToEdit] = useState<any>([])


  //Ouvrir le menu
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  //Fermer le menu
  const handleClose = () => {
    setAnchorEl(null);
  };


  ///////////////////////////////////////// edition ImageIllustration  ///////////////////////////////////////////////////
  //Ouvrir la boite de dialog puis mise à jour de l'objet editActualite
  const handleEditionImageIllustrationDialogOpen = (item: any) => {
    setOpenEditionImageIllustrationDialog(true);
    setEditionApplication(item)
  };

  //Fermer la boite de dialog d'edition 
  const handleEditionImageIllustrationDialogClose = () => {
    setOpenEditionImageIllustrationDialog(false);
  };

  //Enregistrer les modifiactions sur les images illustrant une application
  const handlEditImageIllustrationSave = async (e: any) => {
    e.preventDefault();
    try {
      setLoadingEditionImageIllustration(true);
      //constituer le payload
      const apiPayload: any = {
        idApp: editionApplication.idApp,
        imagesIllustrationEnBase64: arrayImageIllustrationToEdit ? arrayImageIllustrationToEdit : "",
      }
      //Envoie de la requete vers l'api
      const res: any = await apiClient.post(
        SITEWEB_SERVER_BASE_URL,
        "/modifierimagesIllustration",
        apiPayload
      );
      if (res.status === 1) {
        dispatch(updateActualite(res.data));
        setLoadingEditionImageIllustration(false);
        successNotify("Action éffectuée avec succès");
      } else {
        setLoadingEditionImageIllustration(false);
        errorNotify("Echèc de l'opération.");
      }
    } catch (error) {
      console.log("🚀 ~ file: MenuApp.tsx:108 ~ handleSave ~ error:", error)
      setLoadingEditionImageIllustration(false);
      errorNotify("Une erreur s'est produite.");
    }
  };



  ///////////////////////////////////////// edition  ///////////////////////////////////////////////////
  //Ouvrir la boite de dialog puis mise à jour de l'objet editionApplication
  const handleEditionDialogOpen = (item: any) => {
    setOpenEdition(true);
    setEditionApplication(item)
    setArrayToEdit(item.checkListe)
  };

  //Fermer la boite de dialog d'edition 
  const handleEditionDialogClose = () => {
    setOpenEdition(false);
  };


  // envoyer la requete vers api
  const handleiditActualiteSave = async (e: any) => {
    e.preventDefault();
    try {
      setEditUserLoading(true);

      //Obtenir l'image en base 64
      const logoAppEnBase64: any = selectedPhoto ? await convertToBase64(selectedPhoto) : "";

      //constituer le payload
      const apiPayload: any = {
        idApp: editionApplication.idApp,
        libApp: editionApplication.libApp,
        lienPlaystore: editionApplication.lienPlaystore,
        lienAppStore: editionApplication.lienAppStore,
        descriptionApp: editionApplication.descriptionApp,
        logoAppEnBase64: logoAppEnBase64,
        texteComplet: editionApplication.texteComplet,
        lienApp: editionApplication.lienApp,
        logoApp: editionApplication.logoApp,
        checkListe: JSON.stringify(arrayToEdit)
      }
      //Envoie la requete vers l'api
      const res: any = await apiClient.post(
        SITEWEB_SERVER_BASE_URL,
        "/modifierapplication",
        apiPayload
      );
      if (res.status === 1) {
        const newApplication = { ...res.data, checkListe: JSON.parse(res.data.checkListe) }
        dispatch(updateApplication(newApplication));
        setEditUserLoading(false);
        // handleActiveDesactiveDialogClose();
        successNotify("Action éffectuée avec succès");
      } else {
        setEditUserLoading(false);
        errorNotify("Echèc de l'opération.");
      }
    } catch (error) {
      console.log("🚀 ~ file: MenuApp.tsx:108 ~ handleSave ~ error:", error)
      setEditUserLoading(false);
      errorNotify("Une erreur s'est produite.");
    }
  };

  /////////////////////////////////////////////////  suppression  /////////////////////////////////////////////////////////
  //Ouvrir la boite de dialog suppression
  const handleSuppressionDialogOpen = () => {
    setOpenSuppression(true);
  };

  //Fermer la boite de dialog suppression
  const handleSuppressionDialogClose = () => {
    setOpenSuppression(false);
  };

  //Supprimer une application
  const handleDelete = async (e: any) => {
    e.preventDefault();
    try {
      setSuppressionLoading(true);
      //Obtenir le tableau d'element des libAppImageArray
      let libAppImageArray: string[] = []
      applications.map(async (app: any) => {
        if (app.idApp === item.idApp)
          libAppImageArray.push(item.libAppImage)
      })
      //Constitution du payload
      const apiPayload = {
        idApp: item.idApp,
        logoApp: item.logoApp,
        libAppImageArray: libAppImageArray
      };
      // Envoi la requete vers l'api
      const res: any = await apiClient.post(
        SITEWEB_SERVER_BASE_URL,
        "/supprimerapplication",
        apiPayload
      );
      if (res.status === 1) {
        dispatch(deleteApplication(res.data));
        setSuppressionLoading(false);
        handleSuppressionDialogClose();
        successNotify("Action éffectuée avec succès");
      } else {
        setSuppressionLoading(false);
        errorNotify("Echèc de l'opération.");
      }
    } catch (error) {
      console.log("🚀 ~ file: MenuApp.tsx:225 ~ handleDelete ~ error:", error)
      setSuppressionLoading(false);
      errorNotify("Une erreur s'est produite.");
    }
  };




  return (
    <React.Fragment>
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <Tooltip title="Options">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <MoreVertIcon />
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >

        <MenuItem
          onClick={() => {
            handleEditionDialogOpen(item);
          }}
        >
          <ListItemIcon>
            <CreateIcon fontSize="small" />
          </ListItemIcon>
          Modifier
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleSuppressionDialogOpen();
          }}
        >
          <ListItemIcon>
            <DeleteIcon fontSize="small" />
          </ListItemIcon>
          Supprimer
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleEditionImageIllustrationDialogOpen(item);
          }}
        >
          <ListItemIcon>
            <ImageIcon fontSize="small" />
          </ListItemIcon>
          Galérie
        </MenuItem>
      </Menu>

      {/* editer une application */}
      <PostEditDialog
        onClose={handleEditionDialogClose}
        open={openEdition}
        dialogContent={
          <Edit
            editionApplication={editionApplication}
            setEditionApplication={setEditionApplication}
            setSelectedPhoto={setSelectedPhoto}
            arrayToEdit={arrayToEdit}
            setArrayToEdit={setArrayToEdit}
          />}
        actionFunc={handleiditActualiteSave}
        title="Edition"
        editLoading={editLoading}
      />

      {/* editer une application */}
      <PostEditDialog
        onClose={handleEditionImageIllustrationDialogClose}
        open={openEditionImageIllustrationDialog}
        dialogContent={
          <EditImageIllustration
            editionApplication={editionApplication}
            arrayImageIllustrationToEdit={arrayImageIllustrationToEdit}
            setArrayImageIllustrationToEdit={setArrayImageIllustrationToEdit}
          />}
        actionFunc={handlEditImageIllustrationSave}
        title="Edition d'image d'illustration"
        editLoading={loadingEditionImageIllustration}
      />

      {/* Supprimer l'application */}
      <ConfirmAction
        title={`Suppression`}
        dialogContent={`Voulez vous réellement supprimer cette actualité ?`}
        actionLabel="Oui"
        open={openSuppression}
        handleClose={handleSuppressionDialogClose}
        actionFunction={handleDelete}
        addLoading={suppressionLoading}
        iconeSauveButton={<DeleteIcon />}
      />

    </React.Fragment>
  );
}
